"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.owCroSDKInitParams = void 0;
var ow_types_1 = require("../ow.types");
var ow_types_2 = require("../network/ow.types");
exports.owCroSDKInitParams = ow_types_1.owStrictObject().exactShape({
    network: ow_types_2.owNetwork(),
});
//# sourceMappingURL=ow.types.js.map